// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"controls-panel_fullWidth__3xDYB","amount-field":"controls-panel_amount-field__2Jy_Y"};